import React from "react";
import { RCCGrid, RCCLov } from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { IAssociations, IKanban, IKanbanModels } from "../interface";

interface IFiltersAssociationsKanban{
  typeKanban: IKanbanModels;
	associations: IAssociations | undefined;
	selectedKanban: IKanban;
	queryColumns: (associationsX: IAssociations | undefined) => void;
}

const FiltersAssociationsKanban: React.FC<IFiltersAssociationsKanban> = ({
	typeKanban,
	associations,
	selectedKanban,
	queryColumns
}) => {


	const { control } = useForm();
	const { translate } = useTranslation();

	if(typeKanban === IKanbanModels.ACTIONS)
		return <></>;

	if(typeKanban === IKanbanModels.PROJECT_AGILE || typeKanban === IKanbanModels.PROJECT)
		return <>
			<RCCGrid
				container
				item
				spacing={1}
			>
				<RCCGrid
					container
					item
					xs={4}
					justifyContent="flex-end"
				>
					<RCCLov 
						label={translate("Projeto")}
						name="permission"
						required
						control={control}
						routeAPI="Project/LovProjectSForKanban"
						valueProperty="Pra002Id"
						labelProperty="Pra002Titulo"
						elementsPerPage={20}
						isClearable
						key={selectedKanban.kba001Id}
						placeholder={translate("Digite para filtrar as opções")}
						defaultValue={associations?.associationId ? associations?.associationId.toString() : undefined}
						onChangeCapture={(e: any) => {
							queryColumns((() => {
								if(!associations) 
									return {
										associationId: e?.value ? parseInt(e.value, 10) : undefined 
									};
								return {
									...associations,
									associationId: e?.value ? parseInt(e.value, 10) : undefined,
									associationId2: !e?.value || !associations?.associationId2 ? undefined : associations?.associationId2
								};
							})());
						}}
						extraParametersOnLoad={{
							id: selectedKanban.kba001Id
						}}
					/>
				</RCCGrid>
				{typeKanban === IKanbanModels.PROJECT_AGILE && (
					<RCCGrid
						container
						item
						xs={4}
						justifyContent="flex-end"
					>
						<RCCLov 
							name="phase" 
							control={control}
							label={translate("Sprint")}
							routeAPI="ProjectPhase/Lov"
							valueProperty="Pra003Id"
							labelProperty="Pra003Titulo"
							elementsPerPage={20}
							disabled={!associations?.associationId}
							key={associations?.associationId}
							isClearable
							extraParametersOnLoad={{
								projectId:  associations?.associationId
							}}
							placeholder={translate("Digite para filtrar as opções")}
							onChangeCapture={(e: any) => {
								queryColumns((() => {
									if(!associations) 
										return associations;
									return {
										...associations,
										associationId2: e?.value ? parseInt(e.value, 10) : undefined 
									};
								})());
							}}
							required
							defaultValue={associations?.associationId2 ? associations?.associationId2.toString() : undefined}
						/>
					</RCCGrid>
				)}	
			</RCCGrid>	
		</>;

	return <></>;
};

export default FiltersAssociationsKanban;
